import { Drawer, Box, Grid } from "@mui/material";
import { Laptop, List, ShowChart, Group, Search } from "@mui/icons-material";
import routes from "../../../routes";
import { CohereLogo } from "@coherehealth/common";
import { useAuthorized } from "../../../Authorization";
import { QueueViewState } from "@coherehealth/qm-api";
import { useQmNavigationStyles } from "./qmNavigationStyles";
import { NavItem } from "./NavItem";
import { LogoutItem } from "./LogoutItem";
import { useLaunchDarklyFeatureFlag } from "../../../hooks/useLaunchDarklyFeatureFlag";
import { useFindACaseLdContext } from "../../../hooks/useFindACaseLdContext";
interface LeftNavbarProps {
  drawerWidth: number;
  queueViewState: QueueViewState;
}
export const LeftNavBar = ({ drawerWidth, queueViewState }: LeftNavbarProps) => {
  const isQMSupervisor = useAuthorized("SUPERVISOR");
  const isQMManager = useAuthorized("QM_MANAGER");
  const canFindACase = useAuthorized("FIND_A_CASE");
  const findACaseContext = useFindACaseLdContext();
  const { featureFlagEnabled: showFindACase } = useLaunchDarklyFeatureFlag({
    featureFlagName: "qmFindACase",
    context: findACaseContext,
  });
  const classes = useQmNavigationStyles({ drawerWidth });

  // Rendered under My work in the populated view, or standalone in NO_QUEUE (where My work is hidden).
  const findACase = showFindACase && canFindACase && (
    <Box className={classes.navItemContainer}>
      <NavItem testid="qm-nav-find-a-case" to={routes.FIND_A_CASE} label="Find a case" Icon={Search} />
    </Box>
  );

  return (
    <Box component="nav" className={classes.navContainer}>
      <Drawer variant="permanent" anchor="left">
        <Grid container style={{ width: drawerWidth, display: "flex" }}>
          <Box display="flex" justifyContent="center" mt={2} mb={4} width="100%">
            <CohereLogo height={25} width={50} />
          </Box>
          {/* Find a case sits directly under My work in the populated view; in NO_QUEUE (support/QA
              users with no queues, where My work is hidden) it renders on its own so they retain
              access. Gated by the qmFindACase flag AND the FIND_A_CASE ceiling. */}
          {queueViewState === "NO_QUEUE" ? (
            <>
              {findACase}
              <Box position="absolute" left="20px" bottom="24px">
                <LogoutItem queueViewState={queueViewState} />
              </Box>
            </>
          ) : (
            <>
              <Box className={classes.navItemContainer}>
                <NavItem testid="qm-nav-my-work" to={routes.DASHBOARD} label="My work" Icon={Laptop} />
              </Box>
              {findACase}
              {isQMSupervisor && (
                <>
                  <Box className={classes.navItemContainer}>
                    <NavItem testid="qm-nav-queues" to={routes.SUPERVISOR_DASHBOARD} label="Queues" Icon={List} />
                  </Box>
                  <Box className={classes.navItemContainer}>
                    <NavItem testid="qm-nav-reports" to={routes.REPORTS.DASHBOARD} label="Reports" Icon={ShowChart} />
                  </Box>
                  {isQMManager && (
                    <Box className={classes.navItemContainer}>
                      <NavItem testid="qm-nav-users" to={routes.USER_MANAGEMENT} label="Users" Icon={Group} />
                    </Box>
                  )}
                </>
              )}
              <Box position="absolute" left="20px" bottom="24px">
                <LogoutItem queueViewState={queueViewState} />
              </Box>
            </>
          )}
        </Grid>
      </Drawer>
    </Box>
  );
};
